import {useLayoutEffect} from 'react';

import {isTabletOrMobile} from '@zzng/common/utils/agent';

import {attachAgentClassName} from '@/shared/utils/attachAgentClassName';

import DesktopGuidePage from '@/apps/root/components/DesktopGuidePage';
import MobileGuidePage from '@/apps/root/components/MobileGuidePage';

const RootPage = () => {
  useLayoutEffect(() => {
    attachAgentClassName();
  }, []);

  return isTabletOrMobile ? <MobileGuidePage /> : <DesktopGuidePage />;
};

export default RootPage;
